import { render } from "./IndexRightMenu.vue?vue&type=template&id=b5fa9fbe&scoped=true"
import script from "./IndexRightMenu.vue?vue&type=script&lang=js"
export * from "./IndexRightMenu.vue?vue&type=script&lang=js"

import "./IndexRightMenu.vue?vue&type=style&index=0&id=b5fa9fbe&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5fa9fbe"]])

export default __exports__